import type { Invoice } from "@medplum/fhirtypes";

import { getInvoiceServicePayerCode } from "@/billing/utils/service-payer-code";
import { PaymentMethod } from "@/constants/billing";
import {
  BILLING_PAYMENT_METHOD_LABEL_INSURANCE,
  BILLING_PAYMENT_METHOD_LABEL_SELF_PAY,
} from "@/shared/client-billing-payment-method";

/**
 * The "due from" label for a statement, from its service payer code.
 *
 * @param invoice The statement being read.
 * @returns The insurance or self-pay label, or "-" when the statement records neither.
 */
export function getInvoiceDueFromLabel(invoice: Invoice): string {
  const servicePayerMethod = getInvoiceServicePayerCode(invoice);

  if (servicePayerMethod === PaymentMethod.Insurance) return BILLING_PAYMENT_METHOD_LABEL_INSURANCE;
  if (servicePayerMethod === PaymentMethod.SelfPay) return BILLING_PAYMENT_METHOD_LABEL_SELF_PAY;
  return "-";
}
